/**
 *
 * StudentAdmin
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
// import { FormattedMessage } from 'react-intl';
import { Container, Row, Col } from 'react-bootstrap';
import { MODULES_ABSENCES, EMPLOYEE_ROLE, MODULES_LEAVEREQUESTS, MODULES_STUDENTREPORTS, MODULES_IMAGEPREFERENCES } from 'containers/User/constants.js';
import useCurrentRole from 'containers/User/useCurrentRole.js';
import AbsenceReport from 'components/AbsenceReport/index.jsx';
import Connections from 'components/user/UserModal/Connections.jsx';
import StudentConsentItems from 'components/imageUse/StudentConsentItems/index.jsx';
import { ParentList } from 'components/Meetings/index.jsx';
import StudentReports from 'components/StudentReports/index.jsx';
import LeaveRequests from 'components/LeaveRequests/index.jsx';

function StudentAdmin(props) {
  const { student, studentId } = props;
  const role = useCurrentRole();

  const isConnection = role.connections.some((conn) => conn.id === studentId);
  const hasImagePreferences = role.school.modules.includes(MODULES_IMAGEPREFERENCES);

  return (
    <Container fluid>
      <Row className="gx-4 flex-wrap flex-md-nowrap">
        <Col>
          {/* List of meetings for parent */}
          {isConnection && <ParentList studentId={studentId} />}
          <Connections className="mb-4" user={student} type="parents" />
          {studentId && hasImagePreferences && <StudentConsentItems studentId={studentId} />}
          {role.school.modules.includes(MODULES_STUDENTREPORTS) && <StudentReports studentId={studentId} />}
        </Col>
        <Col>
          {(isConnection || role.type === EMPLOYEE_ROLE) && role.school.modules.includes(MODULES_ABSENCES) && studentId
            && <AbsenceReport studentId={studentId} role={role} />}
          {(isConnection || role.type === EMPLOYEE_ROLE) && role.school.modules.includes(MODULES_LEAVEREQUESTS)
            && <LeaveRequests studentId={studentId} user={student} role={role} />}
        </Col>
      </Row>
    </Container>
  );
}

StudentAdmin.propTypes = {
  student: PropTypes.object,
  studentId: PropTypes.number,
};

export default StudentAdmin;
